import { unitBaseTypeEnum } from "../../../../unit-base-type-enum";
import { unitSubtypeEnum, UnitWishModel } from "./LivingMixUnitCard/LivingMixUnitCard";

export const additionalDataForBaseUnitType: UnitWishModel[] = [
    {
        type: unitBaseTypeEnum.C_XS,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['populair onder studenten'],
        images: [
            {
                imageSrc: 'assets/woonmix/C-XS@2x.png',
                label: 'CXS',
            },
        ],
    },
    {
        type: unitBaseTypeEnum.C_S,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['per twee leverbaar'],
        images: [
            {
                imageSrc: 'assets/woonmix/C-S@2x.png',
                label: 'CS',
            },
        ],
    },
    {
        type: unitBaseTypeEnum.C_M,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['1 slaapkamer'],
        images: [
            {
                imageSrc: 'assets/woonmix/C-M@2x.png',
                label: 'CM',
            }
        ],
    },
    {
        type: unitBaseTypeEnum.C_L, // TODO check with Leon as he excluded this from Modal in Figma, need to know whether to sync it accross or not...
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['2 slaapkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/C-M@2x.png',
                label: 'CL',
            }
        ],
    },
    {
        type: unitBaseTypeEnum.C_XL,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['3 slaapkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/C-XL@2x.png',
                label: 'CXL',
            }
        ],
    },
    // {
    //     type: unitBaseTypeEnum.G_XS,
    //     subtype: unitSubtypeEnum.apartment,
    //     active: true,
    //     dirty: false,
    //     notes: [],
    //     images: [
    //         {
    //             imageSrc: 'assets/woonmix/G-XS@2x.png',
    //             label: 'GXS',
    //         }
    //     ]
    // },
    {
        type: unitBaseTypeEnum.G_S,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['per twee leverbaar'],
        images: [
            {
                imageSrc: 'assets/woonmix/G-S@2x.png',
                label: 'GS',
            }
        ]
    },
    {
        type: unitBaseTypeEnum.G_M,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['1 slaapkamer'],
        images: [
            {
                imageSrc: 'assets/woonmix/G-M@2x.png',
                label: 'GM',
            }
        ]
    },
    {
        type: unitBaseTypeEnum.G_L,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['2 slaapkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/G-L@2x.png',
                label: 'GL',
            }
        ]
    },
    {
        type: unitBaseTypeEnum.G_XL,
        subtype: unitSubtypeEnum.apartment,
        active: true,
        dirty: false,
        notes: ['3 slaapkamers', '2 badkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/G-XL@2x.png',
                label: 'GXL',
            }
        ]
    },
    {
        type: unitBaseTypeEnum.H_S,
        subtype: unitSubtypeEnum.maisonette,
        active: true,
        dirty: false,
        notes: ['2 verdiepingen', '1-2 slaapkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/H-S@2x.png',
                label: 'HS',
            }
        ]
    },
    {
        type: unitBaseTypeEnum.H_M,
        subtype: unitSubtypeEnum.maisonette,
        active: true,
        dirty: false,
        notes: ['2-3 verdiepingen', '2-3 slaapkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/H-M@2x.png',
                label: 'HM',
            }
        ]
    },
    {
        type: unitBaseTypeEnum.H_L,
        subtype: unitSubtypeEnum.maisonette,
        active: true,
        dirty: false,
        notes: ['2-3 verdiepingen', '3-5 badkamers'],
        images: [
            {
                imageSrc: 'assets/woonmix/H-L@2x.png',
                label: 'HL',
            }
        ]
    }
]